var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-dropdown-list',{attrs:{"componentId":_vm.componentId,"data-field":_vm.dataField,"showFilter":false,"URLParams":true,"react":{
    and: _vm.reactTo
  },"title":_vm.$t(_vm.title)},scopedSlots:_vm._u([{key:"renderLabel",fn:function(labels){return [_vm._v("\n    "+_vm._s(_vm.$t('Selección'))+" ("+_vm._s(Object.keys(labels).length)+")\n  ")]}},{key:"renderItem",fn:function(ref){
  var label = ref.label;
  var count = ref.count;
return [_c('div',[_vm._v(_vm._s(_vm.$t(label)))]),_c('span',{style:({ marginLeft: 5, color: 'dodgerblue' })},[_vm._v("\n      "+_vm._s(count)+"\n    ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }